export { useRemoteConfigFlag } from './useRemoteConfigFlag';
